/* `{{price.standard}}` / `{{price.premium}}` are substituted at render time by
   Announcement.jsx using the visitor's detected currency — India sees ₹299,
   everywhere else $6.99. Never hardcode a figure here: the bar links to
   /pricing, and a US visitor reading "from ₹299" would land on a USD checkout. */
export const ANNOUNCEMENTS = [
  {
    href: '/pattern-intelligence',
    html: '<b>NEW</b>&nbsp;Pattern Intelligence — the first <em>organizational brain</em> for your company&nbsp;<span class="arr">›</span>',
  },
  {
    href: '/blog-post',
    html: '<b>REPORT</b>&nbsp;The State of the SMB Workday 2026 — what 3M+ hours reveal&nbsp;<span class="arr">›</span>',
  },
  {
    href: '/pricing',
    html: '<b>PRICING</b>&nbsp;Every module, one brain — from {{price.standard}} per user&nbsp;<span class="arr">›</span>',
  },
];
